<template>
  <div class="pos-table-scroll">
    <table class="pos-table">
      <thead><tr><th>App-Studio</th><th>TAC-Standort</th><th v-if="changes">Bisher</th><th>{{ changes ? 'Neu' : 'Quellartikel' }}</th><th>Prüfpunkte</th></tr></thead>
      <tbody>
        <tr v-for="entry in items" :key="entry.studioId">
          <td class="pos-table__title"><strong>{{ entry.name }}</strong></td>
          <td class="pos-table__title">
            <strong>{{ entry.propertyName || (entry.propertyId ? 'TAC-Property ' + entry.propertyId : 'Nicht zugeordnet') }}</strong>
            <small v-if="entry.propertyName">Property {{ entry.propertyId }}</small>
            <small v-for="ressort in entry.ressorts" :key="ressort.id">{{ ressort.name || 'Ressort' }} · {{ ressort.id }}</small>
          </td>
          <td v-if="changes" class="pos-numeric">{{ entry.previousTotal.toLocaleString('de-CH') }}</td>
          <td class="pos-numeric">{{ entry.total.toLocaleString('de-CH') }}</td>
          <td><span v-for="issue in entry.mappingIssues" :key="issue" class="pos-error">{{ issueLabel(issue) }}</span><span v-if="!entry.mappingIssues.length">{{ entry.review.toLocaleString('de-CH') }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { issueLabel } from "./posFormat"
export default {
  props: { items: { type: Array, default: () => [] }, changes: Boolean },
  methods: { issueLabel },
}
</script>
